module.exports = __webpack_public_path__ + "img/romb.1030d7f9.png";